import { type Ref, useImperativeHandle, useState } from "react";

import { TimesheetExportPopover } from "./components/TimesheetExportPopover";

export interface TimesheetExportEmployee {
  name?: string;
}

export interface TimesheetExportHandle {
  open: (
    employeeId: number,
    employee?: TimesheetExportEmployee,
    anchorElement?: HTMLElement,
  ) => TimesheetExportHandle;
  hide: () => TimesheetExportHandle;
}

export type TimesheetExportProps = {
  ref?: Ref<TimesheetExportHandle>;
};

type Target = {
  session: number;
  employeeId: number;
  name?: string;
  anchor: HTMLElement | null;
};

export function TimesheetExport({ ref }: TimesheetExportProps) {
  const [target, setTarget] = useState<Target | null>(null);
  const [open, setOpen] = useState(false);

  const handle: TimesheetExportHandle = {
    open: (employeeId, employee, anchorElement) => {
      setTarget((current) => ({
        session: (current?.session ?? 0) + 1,
        employeeId,
        name: employee?.name,
        anchor: anchorElement ?? null,
      }));
      setOpen(true);

      return handle;
    },
    hide: () => {
      setOpen(false);

      return handle;
    },
  };

  useImperativeHandle(ref, () => handle);

  return (
    <TimesheetExportPopover
      open={open}
      onOpenChange={setOpen}
      session={target?.session ?? 0}
      employeeId={target?.employeeId ?? null}
      employeeName={target?.name}
      anchor={target?.anchor}
    />
  );
}
